import * as ApiConstant from './apiConstant';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core';

export function useSitecoreGraphQLService() {
  const finalUri = `${ApiConstant.baseUrlPrefix}/api/carAdvisory`;
  const httpLink = createHttpLink({
    uri: finalUri,
    headers: {
      sc_apikey: ApiConstant.isProduction ? ApiConstant.sitecoreApiKey : ApiConstant.sitecoreApiKeyLocal,
    },
  });

  const cache = new InMemoryCache({
    // For TabularDatasource queries to work, the client needs to understand the polymorphic relationship between the
    // interfaces listed and the types that implement it. Basically we need to match the fragments in the queries to
    // inform the client about these relationships. We pass a possibleTypes option when creating the InMemoryCache.
    // ref: https://master--apollo-client-docs.netlify.app/docs/react/data/fragments/
    // ref: https://stackoverflow.com/questions/64054089/apollo-client-3-how-to-implement-caching-on-client-side-for-graphql-interfaces
    possibleTypes: {
      _TabularDatasource: ['CompareVehicles', 'CarDetails'],
    },
  });

  const apolloClient = new ApolloClient({
    link: httpLink,
    cache,
  });

  return { apolloClient };
}
